/*
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-05-12 14:34:16
 * @LastEditors: liang
 * @LastEditTime: 2021-09-28 10:03:00
 */
export default {
  methods: {
    familyTree (arr1, id) {
      var temp = []
      var forFn = function (arr, id) {
        for (var i = 0; i < arr.length; i++) {
          var item = arr[i]
          if (item.id === id) {
            temp.push(item)
            forFn(arr1, item.parentId)
            break
          } else {
            if (item.children) {
              forFn(item.children, id)
            }
          }
        }
      }
      forFn(arr1, id)
      return temp
    },
    isMobile (s) {
      return /^1[0-9]{10}$/.test(s)
    },
    isEmail (s) {
      return /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
    },
    isCardNo (card) {
      // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
      return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(card)
    }
  }
}
